<script lang="ts">
    import type { Readable, Writable } from 'svelte/store'

    import Icon from '@iconify/svelte'
    import { cloneDeep } from 'lodash-es'

    import type { IDocument } from 'hydria/HydriaDocument'
    import Modal from 'hydria/components/Modal.svelte'
    import { gettext as _, resolve } from 'hydria/services/gettext'

    import type { ISectionedRevision } from '../models'
    import { SECTION_TYPES } from '../sections'

    interface ILocalDocument extends IDocument {
        page_type?: 'home' | 'generic'
    }

    interface Props {
        revEdit: Writable<ISectionedRevision>
        docSaved: Readable<ILocalDocument>
        afterSectionId?: string
    }

    let { revEdit, docSaved, afterSectionId = null }: Props = $props()

    let showModal = $state(false)

    function addSection(type: string, afterId: string = null) {
        let i = -1
        if (afterId) {
            for (let [j, section] of $revEdit.sections.entries()) {
                if (section.id === afterId) {
                    i = j
                    break
                }
            }
        }
        revEdit.update(($revEdit) => {
            $revEdit.sections.splice(i + 1, 0, cloneDeep(SECTION_TYPES[type].empty()))
            return $revEdit
        })

        showModal = false
    }
</script>

<style>
    .list-side-start,
    .list-side-end {
        background: #aaa;
        height: 1px;
        flex: 1 0 0;
    }
    .list-side-end {
        flex: 0 0 2em;
    }

    .type-grid {
        display: grid;
        grid-template-columns: auto 1fr;
        grid-template-rows: auto;
        gap: 0.75rem 1.25rem;
        align-items: center;
        justify-items: end;
    }
    @media (min-width: 992px) {
        .type-grid {
            grid-template-columns: auto 1fr auto 1fr;
        }
    }

    .help {
        font-size: 0.75rem;
        justify-self: start;
    }

    /* .list-add {
        opacity: 0.5;
    }
    .list-add:hover {
        opacity: 1;
    } */

    .section-add {
        display: flex;
        gap: 0.5rem;
        align-items: center;

        opacity: 0.25;
    }
    .section-add:hover {
        opacity: 1;
    }
</style>

<div class="section-add">
    <div class="list-side-start"></div>
    <div class="list-add">
        <button type="button" class="btn btn-outline-primary btn-sm" onclick={() => (showModal = true)}><Icon inline icon="mdi:playlist-plus" /> {$_('Ajouter une section')}</button>
    </div>
    <div class="list-side-end"></div>
</div>

{#if showModal}
    <Modal close={() => (showModal = false)} modalClasses="modal-xl">
        <div class="modal-header">
            <h5>{$_('Ajout de produits')}</h5>
        </div>
        <div class="modal-body">
            <div class="type-grid">
                {#each Object.entries(SECTION_TYPES) as [_type, data]}
                    {#if data.pageTypes == null || data.pageTypes.has($docSaved.page_type)}
                        <div class="add">
                            <button type="button" class="btn btn-sm btn-outline-primary" onclick={() => addSection(_type, afterSectionId)}>
                                <Icon inline icon="mdi:playlist-plus" />
                                {$resolve(data.title)}
                            </button>
                        </div>
                        <div class="help">
                            {#if data.help}
                                {$resolve(data.help)}
                            {/if}
                        </div>
                    {/if}
                {/each}
            </div>
        </div>
        <div class="modal-footer">
            <button type="button" class="btn btn-outline-secondary" onclick={() => (showModal = false)}>{$_('Fermer')}</button>
        </div>
    </Modal>
{/if}
